/* Version: 3.5.149 */
'use client';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { parse as parse$1, isBefore, format as format$1 } from 'date-fns';
import { enCA, frCA } from 'date-fns/locale';
import dayjs from 'dayjs';
import LANG from '../../../lang/lang.js';

function getDisabledDays(disabledDays) {
  var before = disabledDays.before,
    after = disabledDays.after;
  return {
    // NOTE: dayjs here is specifically required for backward-compatability, because Date is the worst
    // Ticket to migrate to date-fns: https://github.com/manulife-innersource/mux-core/issues/2059
    after: typeof after === 'string' ? dayjs(after).toDate() : after,
    before: typeof before === 'string' ? dayjs(before).toDate() : before
  };
}
function isBeyondMin(date, before) {
  if (before) {
    return isBefore(date, before);
  }
  return false;
}
function isBeyondMax(date, after) {
  if (after) {
    return isBefore(after, date);
  }
  return false;
}
function parse(year, month, day) {
  return parse$1("".concat(year, " ").concat(month, " ").concat(day), 'u MMMM d', new Date());
}

/* format a date for display purposes */
function format(date, lang) {
  // map MUX langs to date-fns locales
  var LOCALE_MAP = _defineProperty(_defineProperty({}, LANG.EN_CA, enCA), LANG.FR_CA, frCA);
  var locale = LOCALE_MAP[lang];
  return format$1(date, 'PPP', {
    locale: locale
  });
}
function dateIsComplete(year, month, day) {
  if (year === null || year === undefined || year === '') {
    return false;
  }
  if (month === null || month === undefined || month === '') {
    return false;
  }
  if (day === null || day === undefined || day === '') {
    return false;
  }
  return true;
}

export { dateIsComplete, format, getDisabledDays, isBeyondMax, isBeyondMin, parse };
